import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "book" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "book--booking-option" }, "Booking option", -1)
const _hoisted_4 = { class: "btn-group" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "book--booking-details" }, "Booking details", -1)
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = { class: "form-date-group" }
const _hoisted_8 = ["disabled"]

import FormDatepicker from '@/components/FormDatepicker.vue'
import FormAutocomplete from '@/components/FormAutocomplete.vue'
import FormControlTextarea from '@/components/FormControlTextarea.vue'
import { useBookNow } from '@/store/book-now'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'Book',
  setup(__props) {

const router = useRouter()
const { form, errors, getVehiclePrices, isPending } = useBookNow()

const onSubmit = async () => {
  await getVehiclePrices()
  router.push({ name: 'book_select_car' })
}

return (_ctx: any,_cache: any) => {
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_AppHeaderProgressBar = _resolveComponent("AppHeaderProgressBar")!
  const _component_Error = _resolveComponent("Error")!
  const _component_FormControl = _resolveComponent("FormControl")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_AppHeader, {
      title: "Book an Excursion",
      steps: [1, 3]
    }),
    _createVNode(_component_AppHeaderProgressBar, {
      from: 0,
      to: 25
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: _normalizeClass(["btn-group--btn", { 'btn-group--btn_active': !_unref(form).bookOnAccount }]),
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(form).bookOnAccount = false), ["prevent"]))
          }, " Personal Use ", 2),
          _createElementVNode("button", {
            class: _normalizeClass(["btn-group--btn", { 'btn-group--btn_active': _unref(form).bookOnAccount }]),
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(form).bookOnAccount = true), ["prevent"]))
          }, " By Account ", 2)
        ]),
        _hoisted_5,
        _createVNode(_component_Error, { error: _unref(errors) }, null, 8, ["error"]),
        _createElementVNode("form", {
          onSubmit: _withModifiers(onSubmit, ["prevent"])
        }, [
          _createVNode(_component_FormControl, {
            placeholder: "passenger name",
            modelValue: _unref(form).name,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).name) = $event)),
            error: _unref(errors).name
          }, null, 8, ["modelValue", "error"]),
          _createVNode(_component_FormControl, {
            placeholder: "e-mail address",
            modelValue: _unref(form).email,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).email) = $event)),
            error: _unref(errors).email
          }, null, 8, ["modelValue", "error"]),
          _createVNode(FormAutocomplete, {
            id: "pickup",
            placeholder: "Pickup address",
            modelValue: _unref(form).pickup,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).pickup) = $event)),
            error: _unref(errors).pickup,
            lat: _unref(form).pickupLat,
            "onUpdate:lat": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).pickupLat) = $event)),
            lng: _unref(form).pickupLng,
            "onUpdate:lng": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).pickupLng) = $event))
          }, null, 8, ["modelValue", "error", "lat", "lng"]),
          _createVNode(FormAutocomplete, {
            id: "destination",
            placeholder: "Dropoff address",
            modelValue: _unref(form).destination,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).destination) = $event)),
            error: _unref(errors).destination,
            lat: _unref(form).destinationLat,
            "onUpdate:lat": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).destinationLat) = $event)),
            lng: _unref(form).destinationLng,
            "onUpdate:lng": _cache[9] || (_cache[9] = ($event: any) => ((_unref(form).destinationLng) = $event))
          }, null, 8, ["modelValue", "error", "lat", "lng"]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(FormDatepicker, {
              modelValue: _unref(form).jobDate,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(form).jobDate) = $event)),
              "auto-apply": "",
              "close-on-auto-apply": "",
              placeholder: "Date of travel",
              position: "left",
              error: _unref(errors).jobStart
            }, null, 8, ["modelValue", "error"]),
            _createVNode(FormDatepicker, {
              modelValue: _unref(form).jobTime,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(form).jobTime) = $event)),
              "enable-time-picker": "",
              "time-picker": "",
              "close-on-auto-apply": "",
              placeholder: "Time",
              position: "right"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(_component_FormControl, {
            placeholder: "Phone number",
            modelValue: _unref(form).mobile,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(form).mobile) = $event)),
            error: _unref(errors).mobile
          }, null, 8, ["modelValue", "error"]),
          _createVNode(_component_FormControl, {
            placeholder: "Amount of passenger",
            modelValue: _unref(form).passengers,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(form).passengers) = $event)),
            error: _unref(errors).passengers
          }, null, 8, ["modelValue", "error"]),
          _createVNode(_component_FormControl, {
            placeholder: "Flight number",
            modelValue: _unref(form).flight,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(form).flight) = $event)),
            error: _unref(errors).flight
          }, null, 8, ["modelValue", "error"]),
          _createVNode(FormControlTextarea, {
            placeholder: "Special note",
            modelValue: _unref(form).pickupInstructions,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(form).pickupInstructions) = $event)),
            error: _unref(errors).pickupInstructions
          }, null, 8, ["modelValue", "error"]),
          _createElementVNode("button", {
            disabled: _unref(isPending),
            type: "submit",
            class: "btn btn-block"
          }, "Next", 8, _hoisted_8)
        ], 40, _hoisted_6)
      ])
    ])
  ]))
}
}

})